import { createFileRoute, useRouter } from '@tanstack/react-router';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { BackendPage, getBackendPageUrl } from '@mews-commander/modules';
import { TrialBalance } from '@mews-commander/modules/src/modules/finance';
import { MewsTeam, RouteType } from '@mews/enums';
import { useFeatureFlag } from '@mews/framework';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Finance/Ledgers/TrialBalance')({
    component: PageComponent,
    beforeLoad: ({ context: { checkFeatureFlag } }) => {
        checkFeatureFlag(FeatureFlag.trialBalanceEnabled);
    },
    staticData: {
        owner: MewsTeam.Accounting,
        type: RouteType.Backend,
        title: TextKey.TrialBalance,
    },
});

function PageComponent() {
    const params = Route.useParams();
    const search = Route.useSearch();
    const { buildLocation } = useRouter();
    const frontendTrialBalanceEnabled = useFeatureFlag(FeatureFlag.trialBalanceFrontendEnabled);

    if (frontendTrialBalanceEnabled) {
        return <TrialBalance />;
    }

    const trialBalanceLocation = buildLocation({ to: '/$currentEnterpriseId/TrialBalance/Index', params });
    return <BackendPage url={getBackendPageUrl({ pathname: trialBalanceLocation.pathname, search })} />;
}
